<template>
  <div class="search">
    <div class="flex-inline flex-between">
      <el-form :inline="true" :model="form" size="small" class="mt-20">
        <el-form-item label="名称">
          <el-input v-model="form.title" placeholder="活动名城"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="全部状态" clearable>
            <el-option label="未开始" :value="1"></el-option>
            <el-option label="进行中" :value="2"></el-option>
            <el-option label="已结束" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" plain>查询</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button @click="goAdd" type="primary" size="small" round>新增活动</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: null,
        status: 1
      }
    }
  },
  methods: {
    onSubmit() {
      this.$emit('on-search', this.form)
    },
    goAdd() {
      this.$router.push('/market/welfare-goods/post')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>